import {
    DesignTokens,
    GivelifyButton,
    GivelifyLabel,
    GivelifyPaper,
} from '@givelify/ui';
import { FormControlLabel, Grid, styled } from '@mui/material';

export const InfoWrapper = styled(GivelifyPaper)(({ theme }) => ({
    borderRadius: '40px',
    background: DesignTokens.color.backgroundComponentSecondary,
    boxShadow: 'none',
    maxWidth: '700px',
    padding: '60px',

    [theme.breakpoints.down('mobile')]: {
        padding: '32px 16px',
        marginBottom: '8px',
    },

    '& .heading': {
        fontSize: '24px',
        fontWeight: 500,
        color: DesignTokens.color.textSecondary,
        lineHeight: '32px',
    },
    '& .sub-heading': {
        color: DesignTokens.color.textSecondary,
        marginBottom: '32px',

        [theme.breakpoints.down('mobile')]: {
            fontSize: '14px',
            fontWeight: 600,
            marginBottom: '28px',
            marginTop: '8px',
        },
    },

    '& .footer-description': {
        color: DesignTokens.color.textSecondary,
    },
    '& .link': {
        fontWeight: 800,
        lineHeight: '24px',
    },
}));

export const OrgInfo = styled('div')(() => ({
    borderRadius: '8px',
    border: `1px solid ${DesignTokens.color.dividerPrimaryLight}`,
    background: DesignTokens.color.backgroundSecondary,
    padding: '24px',
    width: '100%',
    marginBottom: '16px',
    textAlign: 'left',

    '& .additional-info': {
        fontSize: '14px',
        lineHeight: '24px',
        color: 'rgba(115, 113, 127, 1)',
    },
}));

export const LabelContainer = styled('div')(() => ({
    textAlign: 'left',
}));

export const StyledLabel = styled(FormControlLabel)(({ theme }) => ({
    margin: 0,
    [theme.breakpoints.down('mobile')]: {
        display: 'flex',
        alignItems: 'start',
    },

    '& .MuiTypography-root': {
        textAlign: 'left',
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '24px',
        color: DesignTokens.color.textSecondary,
    },
}));

export const StyledButton = styled(GivelifyButton)(({ theme }) => ({
    margin: '32px 0',

    '&[disabled]': {
        color: '#fff',
    },

    [theme.breakpoints.down('mobile')]: {
        fontSize: '16px',
    },
}));

export const DonateButton = styled(GivelifyButton)(({ theme }) => ({
    borderColor: DesignTokens.color.globalGenerosityOrange400,
    color: DesignTokens.color.globalGenerosityOrange400,
    '&:hover': {
        borderColor: DesignTokens.color.globalGenerosityOrange400,
        color: DesignTokens.color.globalGenerosityOrange400,
    },
    [theme.breakpoints.down('mobile')]: {
        fontSize: '16px',
    },
}));

export const FooterDescription = styled(GivelifyLabel)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        fontSize: '14px',
    },
}));

export const DonateSection = styled(Grid)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',

    '& .secondary': {
        color: DesignTokens.color.textSecondary,
    },

    [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column',
        marginBottom: '64px',
    },
}));
